var _defs, _rect, _polygon, _rect2, _polygon2, _rect3, _polygon3, _rect4, _polygon4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b5777bdb-60ae-4921-a6e0-b23872bff102",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .aff4bbec-4b09-4ae1-ba9a-75a8a3f760ea{fill:#1e355f;}.a53189c7-90a6-426b-8e58-15d320acb603{fill:#55bec1;}\r\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aff4bbec-4b09-4ae1-ba9a-75a8a3f760ea",
    x: 13.6658,
    y: 17.4353,
    width: 21.251,
    height: 21.251
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "aff4bbec-4b09-4ae1-ba9a-75a8a3f760ea",
    points: "34.412 26.478 47.85 27.978 34.412 29.478 34.412 26.478"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "aff4bbec-4b09-4ae1-ba9a-75a8a3f760ea",
    x: 48.4743,
    y: 14.4917,
    width: 16.0805,
    height: 16.0805,
    transform: "translate(79.0464 -33.9826) rotate(90)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "aff4bbec-4b09-4ae1-ba9a-75a8a3f760ea",
    points: "58.077 29.752 56.577 43.87 55.077 29.752 58.077 29.752"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "aff4bbec-4b09-4ae1-ba9a-75a8a3f760ea",
    x: 17.2587,
    y: 50.2294,
    width: 11.3212,
    height: 11.3212,
    transform: "translate(-32.9707 78.8092) rotate(-90)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "aff4bbec-4b09-4ae1-ba9a-75a8a3f760ea",
    points: "21.375 50.87 22.875 39.085 24.375 50.87 21.375 50.87"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "a53189c7-90a6-426b-8e58-15d320acb603",
    x: 44.8714,
    y: 44.0455,
    width: 23.4628,
    height: 23.4628,
    transform: "translate(113.2055 111.5538) rotate(180)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "a53189c7-90a6-426b-8e58-15d320acb603",
    points: "45.72 57.369 29.297 55.869 45.72 54.369 45.72 57.369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.74ff92cd9b2355940923e8d23e1480e5.svg";
export { ForwardRef as ReactComponent };